import React,{useState, useEffect, useRef} from "react";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { userurl } from '../../apis/urls'
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";

const ResetPassword = () => {

    const userid = localStorage.getItem('userid');

    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');

    const navigate = useNavigate();
    const RoutToList = () =>{


        navigate(1)
        let role = localStorage.getItem('userrole');
        let associationid = localStorage.getItem('association');
        let schoolid = localStorage.getItem('schoolid')


        if(role === "SUPERADMIN")
        {
            let path = 'newPath'; 
            navigate("/dashboard")
        }else if(role === "ASSOCIATION_USER"){
            let path = 'newPath'; 
            navigate('/associationview/'+associationid)
        }else if(role === "HO_SCHOOL"){
            let path = 'newPath'; 
            navigate('/school_profile/'+schoolid)
        }
        else if(role === "OFFICIALS_USER"){
            let path = 'newPath'; 
            // navigate('/select_rule/')
        }



        
    }



    let onChangePassword = (data) =>{

        let token = "Bearer "+localStorage.getItem('token');

        const dataValues = {
            user:userid,
            password:data.password,
            confirmPassword:data.confirmPassword
        }

        const instance = axios.create({

            baseURL: userurl+"/changepassword",

            timeout: 1000000,

            headers: {'authorization': token}

        });

        instance.put('', dataValues).then((response) =>{

            alert("password changed succesfully.")
            localStorage.removeItem('token');


            let role = localStorage.getItem('userrole');
            let isrule = localStorage.getItem('userisrule');
            let coachlogin = localStorage.getItem('coachlogin')

            if(role === "SUPERADMIN")
            {
                let path = 'newPath'; 
                navigate('/admin')
            }else if(role === "ASSOCIATION_USER"){
                let path = 'newPath'; 
                navigate('/associations/login')
            }else if(role === "HO_SCHOOL"){
                let path = 'newPath'; 
                navigate("/")
            }else if(role === "OFFICIALS_USER"){
                let path = 'newPath'; 
                 navigate('/coaches')
            }
            else if(role === "ATHLETIC_MANAGER" && coachlogin === 'yes'){
                let path = 'newPath'; 
                 navigate('/coaches')
                 localStorage.removeItem('coachlogin');
            }
            else if(role === "ATHLETIC_MANAGER"){
                let path = 'newPath'; 
                 navigate('/')
            }
    

        }).catch((error) =>{
            console.log(error)
        });
    }

    const validationSchema = Yup.object().shape({
        password: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters')
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
                "Password should be combination of one uppercase , one lower case, one special char, one digit and min 8 char long"
            ),
        confirmPassword: Yup.string()
            .required('Confirm Password is required')
            .oneOf([Yup.ref('password'), null], 'Confirm Password does not match')
    });



    const { register, reset, control, handleSubmit, formState:{ errors }, setValue} = useForm({
        resolver: yupResolver(validationSchema)
    }); 



    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Reset Password</h2>
                        </div>
                        <div className="page-rightside-action-column">

                        </div>
                    </div>

                    <form className="needs-validation" onSubmit={handleSubmit(onChangePassword)}>
                        <div className="form-wrpr">
                            <div className="card formcard medium">
                                <div className="card-body">
                                    <span className="nerrors" style={{fontSize: "10px"}}>Password should be combination of one uppercase , one lower case, one special char, one digit and min 8 char long</span><br/><br/><br/>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >New Password<span style={{color: "red"}}>*</span></label>
                                            <input type="password" {...register('password')} name="password" className="form-control justshow bg-dark" placeholder="Enter Password" />
                                        </div>
                                       
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Confirm Password<span style={{color: "red"}}>*</span></label>
                                            <input type="password" {...register('confirmPassword')} name="confirmPassword" className="form-control justshow bg-dark" placeholder="Enter Confirm Password" />
                                        </div>
                                    </div>
                                </div>

                                <div className="error-school">
                                    {errors?.password?.message}
                                </div>
                                <div className="error-school">
                                    {errors?.confirmPassword?.message}
                                </div>

                                <div className="form-group">
                                    <button className="btn btn-primary btn-gisa cancelbtn" onClick={()=>{RoutToList()}}>Cancel</button>
                                    <button className="btn btn-primary btn-gisa" type="submit">Change Password </button>
                                </div>



                                </div>
                            </div>
                        </div>
                    </form>



                </div>
            </aside>
        </div>
    )
}

export default ResetPassword;